<template lang="pug">
  v-dialog.grey(v-model="dialog" scrollable max-width="1100")
    template(v-slot:activator="{ on }")
      v-btn(color="primary" v-on="on" text)
        v-tooltip(top)
          template(v-slot:activator="{ on, attrs }")
            v-icon( v-bind="attrs" v-on="on") mdi-information-outline
          span Information
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span {{ translations.title }}: {{ info.externalReference }}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text.fantasy__scrollbar.px-2.px-sm-6
        v-container(fluid).text-center
          v-lazy( transition="fade-transition")
            v-row.pa-10(justify="center")
              v-col(cols="12" lg="8" md="6" sm="12")
                BaseDefinitionList(:items="roundDetails" keysAlign="text-left text-sm-right")
                  //- b(:class="info.status == 'OPEN' ? 'green--text' : 'red--text'") {{ info.status }}

</template>

<script>
  import { currencyList } from '@/store/variablesGlobals.js';

  export default {
    name: "RoundInfoDialog",
      props: {
      info:{
        type: Object,
        default: function(){
          return {}
        }
      },
      buttonText: {
        type: String,
        default: 'See competition'
      },
    },
    data:() => ({
      currencyList,
      dialog: false,
    }),
    computed: {
      translations() {
        return this.$t("components.roundInfoDialog");
      },
      roundDetails(){
        return [
          {
            key: this.translations.roundId,
            value: this.info.externalReference
          },
          {
            key: this.translations.operator,
            value: this.info.operator.n
          },
          {
            key: this.translations.provider,
            value: this.info.provider.n
          },
          {
            key: this.translations.game,
            value: this.info.game.n
          },
          {
            key: this.translations.moneyIn,
            value: this.info.moneyIn + ' ' + this.getCurrency(this.info.currency)
          },
          {
            key: this.translations.moneyOut,
            value: this.info.moneyOut + ' ' + this.getCurrency(this.info.currency)
          },
          {
            key: this.translations.user,
            value: this.info.user.un
          },
          {
            key: this.translations.start,
            value: this.info.start
          },
          {
            key: this.translations.status,
            value: this.info.status,
            type: 'chip',
            color: ()=>{return this.info.status == 'OPEN' ? 'green' : 'red'}
          },
        ];
      },
    },
    methods: {
      getCurrency(currentCurrency) {
        let curr = this.currencyList.find(item=> item.value === currentCurrency );
        return curr.text;
      },
    }
  }
</script>

<style lang="sass">
</style>